import React from 'react';
import { Link as RouterLink, type LinkProps } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const LocalizedLink: React.FC<LinkProps> = (props) => {
  const { i18n } = useTranslation();
  const lang = i18n.resolvedLanguage || 'en';
  const langPrefix = lang === 'en' ? '' : `/${lang}`;
  
  let to = props.to;
  if (typeof to === 'string' && to.startsWith('/')) {
    // We only prefix public routes. Dashboard is handled via user preferences.
    if (!to.startsWith('/dashboard')) {
        to = `${langPrefix}${to === '/' ? '' : to}`;
        if (to === '') to = '/';
    }
  }

  return <RouterLink {...props} to={to} />;
};
